import * as React from 'react';

import { useSidebar } from '../context';
import { ArticleNavItem } from '../types';

import { cn } from '@/lib/utils';

interface ArticleSearchResultsProps {
  articles: ArticleNavItem[];
}

export function ArticleSearchResults({ articles }: ArticleSearchResultsProps) {
  const {
    ItemLinkComponent,
    activeArticleId,
    handleSearchArticles,
    setSearchValue,
    setLastSelectedArticleId,
    onSelectArticle,
  } = useSidebar();

  const handleSearchResultClick = React.useCallback(
    (articleId: string) => {
      setLastSelectedArticleId(articleId);
      setSearchValue('');
      handleSearchArticles?.('');
      onSelectArticle?.(articleId);
    },
    [handleSearchArticles, onSelectArticle, setLastSelectedArticleId, setSearchValue],
  );

  if (articles.length === 0) {
    return null;
  }

  return (
    <ul aria-label="Search results" className="flex flex-col list-none">
      {articles.map((item) => {
        const isActive = item.id === activeArticleId;

        return (
          <li key={item.id}>
            <ItemLinkComponent
              href={item.href}
              title={item.label}
              data-sidebar-item-id={item.id}
              data-sidebar-item-type="article"
              onClick={() => handleSearchResultClick(item.id)}
              className={cn(
                'relative flex h-9 items-center rounded-md px-1 text-sm truncate',
                isActive
                  ? 'bg-lime-100 font-bold text-primary-foreground after:absolute after:-right-0.5 after:top-1/2 after:h-1/2 after:w-1 after:-translate-y-1/2 after:bg-lime-400'
                  : 'text-inherit hover:bg-dark-200 hover:text-accent-foreground',
              )}
            >
              {item.label}
            </ItemLinkComponent>
          </li>
        );
      })}
    </ul>
  );
}
